import {useState, useCallback, useEffect} from 'react'
import config from '../config'

const storageName = 'userData'

export const useAuth = () => {
  const [authData, setAuthData] = useState({
    token: null, // Keep for backward compatibility, will always be set to true when authenticated
    ready: false,
    userId: null,
    userTypeId: null,
    terminalId: [],
    user:{}
  })

  const login = useCallback((id, usertype_id, terminal_id, user) => {
    const userData = {
      userId: id,
      userTypeId: Number(usertype_id),
      terminalId: terminal_id,
      user: user
    }
    
    setAuthData({
      token: 'authenticated', // Set a flag for backward compatibility
      ready: true, // Mark as ready after login
      ...userData
    })

    // Store user data (but not token) in localStorage for persistence
    localStorage.setItem(storageName, JSON.stringify(userData))
  }, [])


  const logout = useCallback(async () => {
    // Clear state first
    setAuthData({
      token: null,
      userId: null,
      userTypeId: null,
      terminalId: null,
      user: null,
      ready: true
    })
    localStorage.removeItem(storageName)
    
    // Then call backend to clear cookie
    try {
      await fetch(`${config.API_URL}api/logout`, {
        method: 'POST',
        credentials: 'include'
      })
    } catch (e) {
      console.error('Logout error:', e)
    }
  }, [])

  useEffect(() => {
    const validateSession = async () => {
      let data;
      try { data = JSON.parse(localStorage.getItem(storageName)); }
      catch { localStorage.removeItem(storageName); }

      if (data && data.userId) {
        // Try to validate the session with a simple API call
        try {
          const response = await fetch(`${config.API_URL}api/refresh-token`, {
            method: 'POST',
            credentials: 'include'
          })
          
          if (response.ok) {
            const session = await response.json();
            if (session.user) {
              const user = session.user;
              login(user.id, user.usertype_id, user.terminal_id, user);
            } else {
              localStorage.removeItem(storageName);
            }
          } else {
            // Session expired, clear data
            console.log('Session expired on page load')
            localStorage.removeItem(storageName)
          }
        } catch (err) {
          // Network error or other issue, clear data
          console.error('Session validation failed:', err)
          localStorage.removeItem(storageName)
        }
      }
      
      setAuthData((prevData) => ({
        ...prevData,
        ready: true
      }))
    }

    validateSession()
  }, [login])


  return { login, logout, authData }
}
